// src/pages/About.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';
import GeometricDivider from '../components/GeometricDivider';
import useDocumentTitle from '../hooks/useDocumentTitle';

export default function About() {
  useDocumentTitle('About', 'About Arian Kazemi — a software engineer and developer studying Computing at the University of Guelph.');

  return (
    <>
      <section className="hero">
        <div className="hero-content page-container">
          <h1>About Me</h1>
          <p className="tagline">
            Learn more about my background, experience, and interests
          </p>
        </div>
      </section>

      <GeometricDivider />

      <section id="about" className="about page-container">
        <div className="about-details">
          <h2 className="about-heading">Who I Am</h2>
          <p className="about-bio">
            Hi, I’m <strong>Arian Kazemi</strong>, a passionate software developer. I completed my
            Advanced Diploma in Computer Programming &amp; Analysis at <strong>Seneca College</strong> in
            Summer 2025, and I'm now pursuing a <strong>Bachelor of Computing</strong> at
            <strong> University of Guelph</strong>.
          </p>
          <p className="about-bio">
            I genuinely love this field — building things, figuring out how systems fit together, and
            getting better at the craft. Right now that shows up mostly as web applications built with
            React and Node.js, cloud deployments on AWS/Azure, and exploring machine learning, but the
            underlying interest is just being a good software engineer, not any one stack.
          </p>

          <div className="about-cta">
            <Link to="/contact" className="btn primary">Get in Touch</Link>
            <Link to="/projects" className="btn secondary">See My Work</Link>
          </div>
        </div>
      </section>

      <GeometricDivider />
    </>
  );
}
